import { takeLatest } from 'redux-saga/effects';
import { GlobalActions, SnapshotManager } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';

export const snapshotManager = new SnapshotManager(App.RS);

export function* watchStateSnapshot() {
  yield takeLatest(
    GlobalActions.CREATE_STATE_SNAPSHOT,
    safeSaga(snapshotManager.createSnapshot, App.RS),
  );
  yield takeLatest(
    GlobalActions.RESTORE_STATE_SNAPSHOT,
    safeSaga(snapshotManager.restoreSnapshot, App.RS),
  );
}
